import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../retailer.service';

@Component({
  selector: 'app-new-retailer-smart',
  template: `<app-new-retailer [salesReps]='salesReps' [businessTypes]='businessTypes' [pricelists]='pricelists'></app-new-retailer>`,
  styles: [
  ]
})
export class NewRetailerSmartComponent extends FeaturesBaseComponent implements OnInit {
  configValues;
  salesReps;
  businessTypes;
  pricelists:any = [];

  constructor(private retailerService: RetailerService) {
    super();

  }

  ngOnInit(): void {

    this.getDropDownValues();

  }

  getDropDownValues() {

    let salesRepsBehavior = this.retailerService.getActiveSalesRepresentatives();
    let businessTypeBehavior = this.retailerService.getConfigValues();
    //let pricelistsBehavior = this.retailerService.getActivePricelists();

    this.salesReps = [];
    forkJoin([salesRepsBehavior, businessTypeBehavior]).subscribe(results => {
      let _salesReps: any = results[0];
      this.salesReps = _salesReps.data; 
      let _businessTypes: any = results[1];
      this.businessTypes = _businessTypes.data;
      //let _priceList: any = results[2];
      //this.pricelists = _priceList.data;
    })
  }
  private initForm() {


  }

  onSubmit() {

  }
}
